"use client";

/**
 * Home / dashboard placeholder za erp.grozd.me.
 *
 * Auth gate i topbar dolaze iz layout.tsx (ErpShell wrapper) — ova stranica
 * samo renderuje sadržaj. Dashboard kartice, KPI, recent activity dolaze
 * iterativno.
 */

export default function HomePage() {
  return (
    <div
      style={{
        minHeight: "calc(100vh - 56px)",
        padding: "48px 24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
      }}
    >
      <h1
        className="font-brand"
        style={{
          fontWeight: 800,
          fontSize: 28,
          color: "var(--ink)",
          letterSpacing: "-0.02em",
          textAlign: "center",
        }}
      >
        Tenant ERP — V3 skeleton
      </h1>
      <p
        className="font-body"
        style={{
          color: "var(--n400)",
          maxWidth: 560,
          textAlign: "center",
          fontSize: 14,
          lineHeight: 1.55,
        }}
      >
        Dashboard, fakturisanje, magacin, računovodstvo, POS — sve dolazi
        iterativno. Trenutno: minimalan shell sa topbar-om i logout-om kroz
        zajednički <code>@grozd/auth-client</code> helper.
      </p>
      <p
        className="font-body text-[10px]"
        style={{
          color: "var(--n400)",
          marginTop: "auto",
          paddingTop: 32,
          textAlign: "center",
        }}
      >
        ERP build: 2026-05-03 — deploy verifikacija
      </p>
    </div>
  );
}
